import { createSlice } from '@reduxjs/toolkit';
import { LastMovement } from '../../../core/entities/general/LastMovement.entity';

export interface ITransactionStore extends LastMovement {
  bankId: string;
}

interface TransactionState {
  transaction: ITransactionStore;
  accountNameSelected: string;
  accountNumberSelected: string;
  errorMessage?: string;
}

const initialState: TransactionState = {
  transaction: {
    date: '',
    account: '',
    accountType: '',
    detail: '',
    amount: 0,
    bankId: '',
  },
  accountNameSelected: '',
  accountNumberSelected: '',
  errorMessage: undefined,
};

export const transactionSlice = createSlice({
  name: 'transaction',
  initialState,
  reducers: {
    setSelectTransaction: (state, action) => {
      state.transaction = action.payload;
    },
    setAccountNameSelected: (state, action) => {
      state.accountNameSelected = action.payload;
    },
    setAccountNumberSelected: (state, action) => {
      state.accountNumberSelected = action.payload;
    },
  },
});

export const {
  setSelectTransaction,
  setAccountNameSelected,
  setAccountNumberSelected,
} = transactionSlice.actions;
